/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { JiraSpaRoute, RouterContext } from '@atlassian/react-resource-router';
import type { RouteName } from '@jira/platform__routing-route-name-types/src/RouteName.tsx';
import {
	MENU_ID_CUSTOMER_SERVICE,
	MENU_ID_CUSTOMER_SERVICE_ANALYTICS,
	MENU_ID_CUSTOMER_EXPERIENCES_VIEW_ALL,
	MENU_ID_CUSTOMERS,
	MENU_ID_DASHBOARDS,
} from '../../../../constants.tsx';
import type { SelectedPath } from '../../../../types.tsx';

const routes = new Set<RouteName>([
	'customer-service-helpcenter',
	'customer-service-helpcenter-analytics',
	'customer-service-customers',
	'customer-service-customer-details',
	'customer-service-organizations',
	'customer-service-organization-details',
	'customer-service-products',
]);

function convert(routeContext: RouterContext<JiraSpaRoute>): SelectedPath {
	const routeName: RouteName = routeContext.route.name;
	const path: string[] = [];
	return convertRouteToPath({ routeName, path });
}

function convertNew(args: { routeName: RouteName }): SelectedPath {
	const { routeName } = args;
	const path: string[] = [];
	return convertRouteToPath({ routeName, path });
}

function convertRouteToPath(args: { routeName: RouteName; path: string[] }): SelectedPath {
	const { routeName, path } = args;

	switch (routeName) {
		case 'customer-service-helpcenter':
			path.push(MENU_ID_CUSTOMER_SERVICE);
			path.push(MENU_ID_CUSTOMER_EXPERIENCES_VIEW_ALL);
			break;

		case 'customer-service-helpcenter-analytics':
			// Analytics appears nested under dashboards
			path.push(MENU_ID_DASHBOARDS);
			path.push(MENU_ID_CUSTOMER_SERVICE_ANALYTICS);
			break;

		case 'customer-service-customers':
		case 'customer-service-customer-details':
		case 'customer-service-organizations':
		case 'customer-service-organization-details':
		case 'customer-service-products':
			path.push(MENU_ID_CUSTOMERS);
			break;

		default:
	}

	return path;
}

export const customerServiceConverter: {
	routes: Set<RouteName>;
	convert: typeof convert;
	convertNew: typeof convertNew;
} = { routes, convert, convertNew };
